import { TableItemActionsNew, Icons } from 'components';
import React from 'react';

const columns = (navigate, setDialog, changeStateOfBranch, actionsList) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه تنخواه گردان',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'نام تنخواه گردان',
    field: 'name',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'نام و نام‌خانوادگی مالک',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd?.owner ? `${rd?.owner?.name || '-'}` : '-'),
  },
  {
    title: 'وضعیت',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd.branchInfoSrv?.enable ? 'فعال' : 'غیرفعال'),
  },
  ...(checkShowActionColumn(actionsList) ? [{
    title: 'عملیات',
    field: 'operationSmall',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rd) => (
      <TableItemActionsNew
        iconButton
        startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
        title=""
        otherMenus={[
          {
            title: 'عملیات مالی',
            isShow: !!(actionsList['imprestListTransferAction'] ||
              actionsList['imprestListDelegationAction'] ||
              actionsList['imprestListFinancialLimitAction']),
            isOpen: false,
            id: 'FinancialOperation',
            children: [

              {
                title: 'شارژ',
                isShow: !!actionsList['imprestListTransferAction'],
                onClick: () => {
                  navigate(
                    `/TransferToImprest?username=${rd.username}&fullName=${rd.name}+&userId=${rd.userId}&userInfoType=username&userInfo=${rd.username}&transferType=wallet&directFrom=imprest`,
                  );
                },
              },
              {
                title: 'دشارژ',
                isShow: !!actionsList['imprestListTransferAction'],
                onClick: () => {
                  navigate(
                    `/WithdrawToParent/${rd.id}`,
                  );
                },
              },
              {
                title: 'تفویض وجه',
                isShow: !!actionsList['imprestListDelegationAction'],
                onClick: () => navigate(`/DelegationToUser?username=${rd.username}&Type=Imprest`, { state: rd }),
              },
              {
                title: 'سقف مالی شعبه',
                isShow: !!actionsList['imprestListFinancialLimitAction'],
                onClick: () => navigate(`/Branch/${rd.id}/financial?imprest=true`, { state: rd }),
              },
            ],
          },
          {
            title: 'عملیات از طرف تنخواه گردان',
            isShow: !!(actionsList['imprestListOtherTransferAction'] ||
              actionsList['imprestListOtherInvoiceCreateAction'] ||
              actionsList['imprestListOtherBalanceAction']),
            isOpen: false,
            id: 'FromBranch',
            children: [
              {
                title: 'انتقال وجه',
                isShow: !!actionsList['imprestListOtherTransferAction'],
                onClick: () => {
                  navigate(`/Imprest/ImprestTransferCredit?userId=${rd?.userId}`);
                },
              },
              {
                title: 'صدور فاکتور',
                isShow: !!actionsList['imprestListOtherInvoiceCreateAction'],
                onClick: () => {
                  navigate(`/Imprest/IssueInvoice/${rd.id}`, { state: rd });
                },
              },

              {
                title: 'امکان دریافت موجودی',
                isShow: !!actionsList['imprestListOtherBalanceAction'],
                onClick: () => {
                  navigate(`/Imprest/ReceiveInventory/${rd.id}`, { state: rd });
                },
              },
            ],
          },
          {
            title: 'عملیات',
            isShow: !!(actionsList['imprestListUpdateAction'] || actionsList['imprestListUpdateActivationAction']),
            isOpen: false,
            id: 'operatin',
            children: [
              {
                title: 'ویرایش',
                isShow: !!actionsList['imprestListUpdateAction'],
                onClick: () => navigate(`/Imprest/${rd.id}`, { state: rd }),
              },
              {
                title: rd?.branchInfoSrv?.enable ? 'غیرفعال‌سازی شعبه' : 'فعال‌سازی شعبه',
                isShow: !!actionsList['imprestListUpdateActivationAction'],
                onClick: () => {

                  setDialog({
                    title: rd?.branchInfoSrv?.enable
                      ? ` غیرفعال‌سازی شعبه ${rd.name}`
                      : ` فعال‌سازی شعبه ${rd.name} `,
                    content: 'آیا از انجام این عملیات اطمینان دارید؟',
                    open: true,
                    data: rd,
                    type: 'ChangeStateActionBtn',
                    onAccept: () => {
                      changeStateOfBranch([rd], !rd?.branchInfoSrv?.enable);
                    },
                  });
                },
              },
            ],
          },

          {
            title: 'گزارشات',
            isShow: !!(actionsList['imprestListDetailAction'] || actionsList['imprestListBillAction']),
            isOpen: false,
            id: 'reports',
            children: [
              {
                title: 'جزئيات',
                isShow: !!actionsList['imprestListDetailAction'],
                onClick: () => navigate(`/Branch/${rd.id}/detail?Imprest=true`, { state: rd }),
              },

              {
                title: 'صورت حساب',
                isShow: !!actionsList['imprestListBillAction'],
                onClick: () => {
                  navigate(`/Branch/Transactions/${rd.id}?imprest=true`, { state: rd });
                },
              },
            ],
          },
        ]}
      />
    ),
  }] : []),
];
/**
 * بررسی میکند که آیا حداقل یک مورد از اکشن ها دسترسی دارد یا خیر که ستون عملیات را نشان دهد یا مخفی کند
 */
const checkShowActionColumn = (actionsList) => {
  if (actionsList['imprestListTransferAction'] ||
    actionsList['imprestListDelegationAction'] ||
    actionsList['imprestListFinancialLimitAction'] ||
    actionsList['imprestListOtherTransferAction'] ||
    actionsList['imprestListOtherInvoiceCreateAction'] ||
    actionsList['imprestListOtherBalanceAction'] ||
    actionsList['imprestListUpdateAction'] ||
    actionsList['imprestListUpdateActivationAction'] ||
    actionsList['imprestListDetailAction'] ||
    actionsList['imprestListBillAction']) {
    return true
  } else {
    return false
  }
}
const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
